import { render, staticRenderFns } from "./TopMenu.vue?vue&type=template&id=3186aa0e&"
import script from "./TopMenu.vue?vue&type=script&lang=js&"
export * from "./TopMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3186aa0e')) {
      api.createRecord('3186aa0e', component.options)
    } else {
      api.reload('3186aa0e', component.options)
    }
    module.hot.accept("./TopMenu.vue?vue&type=template&id=3186aa0e&", function () {
      api.rerender('3186aa0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/common/TopMenu.vue"
export default component.exports